import React from 'react';

interface HourglassProps {
  className?: string;
}

const Hourglass: React.FC<HourglassProps> = ({ className }) => {
  return (
    <svg 
      className={className} 
      fill="none" 
      height="26" 
      viewBox="0 0 26 26" 
      width="26" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M6.00015 1V1.47445C6.00015 6.65175 7.93786 11.105 10.8926 12.7526V13.0621C7.93781 14.7097 6.0001 19.1629 6.0001 24.3403V24.8148H20.5615V24.3403C20.5615 19.1326 18.591 14.6779 15.6088 13.0573V12.7574C18.5908 11.1366 20.5615 6.68191 20.5615 1.4744V1H6.00015ZM6.9618 1.94885H19.6C19.4742 6.84645 17.4295 10.8621 14.9313 12.0495L14.6599 12.1781V13.6381L14.9313 13.7666C17.4294 14.954 19.474 18.9685 19.6 23.8658H6.9618C7.08652 18.996 9.10096 14.9751 11.5765 13.7635L11.8431 13.6334V12.1813L11.5765 12.0512C9.10106 10.8396 7.08646 6.81867 6.9618 1.94885Z" 
        fill="currentColor" 
      />
      <path 
        d="M9 5.20795C11.6932 6.41375 15.0915 6.41223 18.0168 5C17.2894 7.70375 15.7628 9.64313 13.9639 9.94173C14.04 10.0449 14.086 10.1718 14.086 10.3099C14.086 10.6532 13.8074 10.932 13.464 10.932C13.1206 10.932 12.8419 10.6532 12.8419 10.3099C12.842 10.1752 12.886 10.0443 12.9673 9.93695C11.225 9.63287 9.74415 7.79297 9 5.20795Z" 
        fill="currentColor" 
        fillOpacity="0.5" 
      />
      <path 
        d="M12.8419 12.3174C12.8419 11.974 13.1206 11.6953 13.464 11.6953C13.8074 11.6953 14.086 11.974 14.086 12.3174C14.086 12.6608 13.8074 12.9394 13.464 12.9394C13.1206 12.9394 12.8419 12.6608 12.8419 12.3174Z" 
        fill="currentColor" 
        fillOpacity="0.5" 
      />
      <path 
        d="M12.8419 14.3121C12.8419 13.9688 13.1206 13.69 13.464 13.69C13.8074 13.69 14.086 13.9688 14.086 14.3121C14.086 14.6555 13.8074 14.9341 13.464 14.9341C13.1206 14.9341 12.8419 14.6555 12.8419 14.3121Z" 
        fill="currentColor" 
        fillOpacity="0.5" 
      />
      <path 
        d="M12.8419 16.3196C12.8419 15.9762 13.1206 15.6975 13.464 15.6975C13.8074 15.6975 14.086 15.9762 14.086 16.3196C14.086 16.6629 13.8074 16.9417 13.464 16.9417C13.1206 16.9417 12.8419 16.6629 12.8419 16.3196Z" 
        fill="currentColor" 
        fillOpacity="0.5" 
      />
      <path 
        d="M9.62045 21.5659C11.1247 19.0326 12.2917 17.7382 13.4703 17.724C14.649 17.7098 15.84 18.9759 17.39 21.5659H9.62045Z" 
        fill="currentColor" 
        fillOpacity="0.5" 
      />
    </svg>
  );
};

export default Hourglass;